import { Routes } from "@angular/router";
import { ApiDocumentationComponent } from "./components/api-documentation/api-documentation.component";

export const appRoutes: Routes = [
  {
    path: "",
    component: ApiDocumentationComponent,
  },
];
